module.exports = __webpack_public_path__ + "static/media/Stonk-Post-Page.aa65e7c8.png";